
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSearchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasicFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserRank"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserTopicsCount"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSolutionCount"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserRegistrationData"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kudosReceivedCount"},"arguments":[],"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("./UserBasicFields.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./UserAvatar/UserAvatar.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./UserRank/UserRank.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./UserTopicsCount.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./UserSolutionCount.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./UserRegistrationData.fragment.graphql").definitions));


    module.exports = doc
  
